import React from "react";

export default function Banner(props){
    const{heading, title, paragraph, mission, myTitle, myMission}=props;
    return(
        <>
            <div className={heading}>
                <span className={title}>{myTitle}</span>
            </div>

            <div className={paragraph}>
                <span className={mission}>{myMission}</span>
            </div>
        </>
    )
}